// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__gTlal","choiceBoxes":"toolbarselects_choiceBoxes__2q9Sn","simpleField":"toolbarselects_simpleField__14kwB"};